module.exports = __webpack_public_path__ + "img/eye_sight_good.77d61789.svg";